import React from 'react';
import cx from 'classnames';
import { Tooltip } from 'antd';

import CustomIcon from 'components/common/CustomIcon';

const RefreshButton = ({ className = '', refreshMeta, handleRefresh }) => (
    <Tooltip
        title={refreshMeta.error && refreshMeta.error.message}
        arrowPointAtCenter={true}
        placement="left"
        overlayClassName="tooltip-error"
    >
        <a className={cx(className, { 'error-icon': refreshMeta.error })} onClick={() => handleRefresh()}>
            <CustomIcon type="refresh" />
        </a>
    </Tooltip>
);

export default RefreshButton;
